import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import type EstensaModel from 'estensa-module';
import { constant } from 'lodash-es';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Logger } from '@se/se.platform.base';
import { ServerRootService } from '../../utils/routing/serverroot.service';
import { BrokerDataFilterExam } from 'estensa-module';


type BaseDataResponse<T> = {
    success: boolean;
    message: string;
    data: T | null;
};


export const BROKER_MODULE_BROKER_SERVICE = new InjectionToken('broker.module.broker.service');

export interface IBrokerServiceNg1 {
    findStudies(searchParams: EstensaModel.BrokerDataFilterStudy): { $promise: Promise<EstensaModel.BrokerDataStudy[]> };
}

@Injectable()
export class NullBrokerService implements IBrokerServiceNg1 {
    findStudies = constant({ $promise: Promise.resolve(null) });
}

@Injectable({
    providedIn: 'root',
})


export class BrokerService extends ServerRootService implements IBrokerServiceNg1 {
    protected get headers(): HttpHeaders {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'dataType': "json"
        })
        return headers;
    }

    constructor(

        @Inject(BROKER_MODULE_BROKER_SERVICE)
        private brokerService: IBrokerServiceNg1,
        private http: HttpClient,
        private logger : Logger
    ) {
        super();
    }

    findStudies(searchParams: EstensaModel.BrokerDataFilterStudy) {
        return this.brokerService.findStudies(searchParams) ;
    }

    _findStudies (searchParams: EstensaModel.BrokerDataFilterStudy) : Observable<BaseDataResponse<EstensaModel.BrokerDataStudy[]>>  {
        // /Estensa.Rest/Client/api/Broker/FindStudies
        let url : string = this.getServerRoot()+ '/Broker/FindStudies';
        let body : string = JSON.stringify(searchParams)
        return this.http.post<EstensaModel.BrokerDataStudy[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.BrokerDataStudy[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            } )
        );
    }

    findExams (searchParams: EstensaModel.BrokerDataFilterExam | undefined) : Observable<BaseDataResponse<EstensaModel.BrokerDataExam[]>>  {
        //http://192.168.72.135/Estensa.Rest/Client/api/Broker/FindExams
       // /Estensa.Rest/Client/api/Broker/FindExams
        let url: string = this.getServerRoot() + '/Broker/FindExams';
        let body: string = JSON.stringify(searchParams ?? new BrokerDataFilterExam())
       return this.http.post<EstensaModel.BrokerDataExam[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.BrokerDataExam[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            } )
        );
    }

    getAssociationsOnPIRDisplay (searchParams: any) : Observable<BaseDataResponse<EstensaModel.IBrokerDataDisplay[]>>  {
       //let url : string = this.getAuthRoot();
       let url : string = this.getServerRoot() + '/Broker/GetAssociazioniOnPIRDisplay';
       
       let body : string  = JSON.stringify(searchParams)
       return this.http.post<any[]>(url,body, this.buildOptions()).pipe(
        map((response: any[]) => {
            return {
                success: true,
                message: "Success",
                data: response.map( r => r as EstensaModel.IBrokerDataDisplay )
                //data: response
            }
        }),
        catchError(error =>{
            this.logger.error(error);
            return of(
                {
                    success: false,
                    message: error,
                    data: null
                }
            )
        } )
    );
      /*  return this.http.post<EstensaModel.IBrokerDataDisplay[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.IBrokerDataDisplay[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            } )
        ); */
    }

    associateStudies (data: EstensaModel.BrokerSetAssociationData[]) : Observable<BaseDataResponse<EstensaModel.BrokerSetAssociationData[]>>  {
        //url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.ASSOCIATE + this.config.SERVICE_CONFIG.POSTFIX_URL,
        let url : string = this.getServerRoot() + '/Broker/Associate';
        
        //http://192.168.72.157/Estensa.Rest/Client/api/Broker/Associate
        let body : string = JSON.stringify(data)
        return this.http.post<EstensaModel.BrokerSetAssociationData[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.BrokerSetAssociationData[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            })
        );
    };


     removeAssociation (data: EstensaModel.BrokerSetAssociationData[]) : Observable<BaseDataResponse<EstensaModel.BrokerSetAssociationData[]>>  {
        //url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.REMOVEASSOCIATION + this.config.SERVICE_CONFIG.POSTFIX_URL,
        let url : string = this.getServerRoot() + '/Broker/RemoveAssociation';
        let body : string = JSON.stringify(data)
        return this.http.post<EstensaModel.BrokerSetAssociationData[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.BrokerSetAssociationData[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            })
        );
    };

    
    validateAssociation (data: EstensaModel.BrokerSetAssociationData[]) : Observable<BaseDataResponse<EstensaModel.BrokerSetAssociationData[]>>  {
        //url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.VALIDATEASSOCIATION + this.config.SERVICE_CONFIG.POSTFIX_URL,
        let url : string = this.getServerRoot() + '/Broker/ValidateAssociation';
        let body : string = JSON.stringify(data)
        return this.http.post<EstensaModel.BrokerSetAssociationData[]>(url,body, this.buildOptions()).pipe(
            map((response: EstensaModel.BrokerSetAssociationData[]) => {
                return {
                    success: true,
                    message: "Success",
                    data: response
                }
            }),
            catchError(error =>{
                this.logger.error(error);
                return of(
                    {
                        success: false,
                        message: error,
                        data: null
                    }
                )
            })
        );
    };



/* 
    public GetActions(): EstensaModel.IBrokerSetAssociationDataResource {
        return <EstensaModel.IBrokerSetAssociationDataResource>this.resource(
            this.baseUrl,
            null,
            {
                associate: {
                    method: this.config.HTTP.POST_METHOD,
                    url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.ASSOCIATE + this.config.SERVICE_CONFIG.POSTFIX_URL,
                    isArray: true
                },
                removeAssociation: {
                    method: this.config.HTTP.POST_METHOD,
                    url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.REMOVEASSOCIATION + this.config.SERVICE_CONFIG.POSTFIX_URL,
                    isArray: true
                },
                validateAssociation: {
                    method: this.config.HTTP.POST_METHOD,
                    url: this.baseUrl + this.config.SERVICE_CONFIG.SERVICE_URL.VALIDATEASSOCIATION + this.config.SERVICE_CONFIG.POSTFIX_URL,
                    isArray: true
                }
            }
        );
    }
 */
}
